var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","title":"视维科技"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }